export default function Contact() {
  return (
    <section id="contact" className="bg-gray-900 py-16 px-6 text-white text-center">
      <h3 className="text-3xl text-red-500 font-bold mb-6">Contact Me</h3>
      <form
        action="https://formspree.io/f/xwpodeye"  // <-- replace this
        method="POST"
        className="max-w-xl mx-auto bg-gray-800 p-6 rounded shadow"
      >
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
          className="w-full mb-4 px-4 py-2 rounded bg-gray-700 text-white"
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
          className="w-full mb-4 px-4 py-2 rounded bg-gray-700 text-white"
        />
        <textarea
          name="message"
          rows="5"
          placeholder="Your Message"
          required
          className="w-full mb-4 px-4 py-2 rounded bg-gray-700 text-white"
        ></textarea>
        
        {/* Optional - disable captcha and redirect to thank you page */}
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_next" value="https://yourportfolio.com/thank-you" />

        <button
          type="submit"
          className="bg-red-600 px-6 py-2 rounded hover:bg-red-700 transition"
        >
          Send Message
        </button>
      </form>
    </section>
  );
}
